import { Permission } from './permission';

// Single source of truth for "which route does this permission's feature live at".
// Consumed by AuthService.menuPriorityRoutes (login/reload redirect) and
// RfrNavAdminComponent.getClientMenuItems() (sidebar links) so a route only
// ever needs to be updated in one place.
export const PERMISSION_ROUTES: Record<Permission, string> = {
  [Permission.Dashboard]: '/main/admin',
  [Permission.RosterCalendar]: '/main/admin/job-calendar',
  [Permission.Chat]: '/main/chat',
  [Permission.VoiceComms]: '/main/ptt',
  [Permission.OnboardingReview]: '/main/admin/onboarding-review',
  [Permission.LeaveRequests]: '/main/admin/leave-requests',
  [Permission.UsersAdmin]: '/main/admin/user-list/staff',
  [Permission.UsersStaff]: '/main/admin/user-list/knight',
  [Permission.UsersWorkgroups]: '/main/admin/workgroups/working-group',
  [Permission.UsersRolePermissions]: '/main/admin/role-permissions',
  [Permission.SetupAssignments]: '/main/admin/assignment',
  [Permission.SetupSites]: '/main/admin/event-geofencing',
  [Permission.SetupShifts]: '/main/admin/sites/shift',
  [Permission.SetupRosters]: '/main/admin/workgroups/roster',
  [Permission.SetupTags]: '/main/admin/tags-management',
  [Permission.SetupWorkPolicies]: '/main/admin/workforce-policies',
  [Permission.SetupOnboardingForms]: '/main/admin/onboarding-form-config',
  [Permission.AttendanceManagementRosterBased]: '/admin-fullscreen/attendant-management',
  [Permission.AttendanceManagementStaffBased]: '/admin-fullscreen/staff-standby-matrix',
  [Permission.AttendanceResolution]: '/admin-fullscreen/attendant-resolution',
  // For System Admin only
  [Permission.ManageClient]: '/main/admin/client-list',
  [Permission.ManageAllUsers]: '/main/admin/user-list/user',
  [Permission.ManageIssues]: '/main/issue-report',
  [Permission.ManageBeacons]: '/main/admin/beacon-device/adding/new-device'
};
